import React from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import BlockUI from 'react-block-ui';

const PrivateRoute = ({ component: Component, auth, ...rest }) => (
	<Route {...rest} render={props => (
		auth.isAuthenticated ? (
			// wait for user to be loaded before showing the dashboard
			<BlockUI blocking={!auth.currentUser.id} renderChildren={false}>
				<Component {...props} />
			</BlockUI>
		) : (
			<Redirect to={{
				pathname: '/login',
				state: { from: '/' }
			}} />
		)
	)} />
);

const mapStateToProps = (state, ownProps) => ({
	auth: state.auth
});

export default connect(mapStateToProps)(PrivateRoute);